/**
 * @generated SignedSource<<58ab05679751bcc2b938ae118668f4c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetIntegrationTurnpikeSize = "TWO_X_ONE" | "TWO_X_TWO";
export type CreateWidgetIntegrationTurnpikeInput = {
  positionX: number;
  positionY: number;
  size: WidgetIntegrationTurnpikeSize;
};
export type WAIntegrationTurnpikeMutation$variables = {
  input: CreateWidgetIntegrationTurnpikeInput;
  storecastId: string;
};
export type WAIntegrationTurnpikeMutation$data = {
  readonly dashboard: {
    readonly createWidgetIntegrationTurnpike: {
      readonly id: string;
    };
  };
};
export type WAIntegrationTurnpikeMutation = {
  response: WAIntegrationTurnpikeMutation$data;
  variables: WAIntegrationTurnpikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetIntegrationTurnpike",
        "kind": "LinkedField",
        "name": "createWidgetIntegrationTurnpike",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationTurnpikeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationTurnpikeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "db77145d873775c027d1c22a6784e607",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationTurnpikeMutation",
    "operationKind": "mutation",
    "text": "mutation WAIntegrationTurnpikeMutation(\n  $storecastId: ID!\n  $input: CreateWidgetIntegrationTurnpikeInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetIntegrationTurnpike(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b5f7f4d6b820e24bcad7598c9666201";

export default node;
